// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".g-recaptcha{margin:1rem 0}.g-recaptcha>div:after{color:red;content:\"*\";left:4px;position:relative}.g-recaptcha>div{display:flex;position:relative}.g-recaptcha>div>div{margin:auto}.g-recaptcha[data-error=true]:after{color:red;content:\"This is required\";font-size:11px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
